// extracted by mini-css-extract-plugin
export default {"versionNumber":"txsOyA"};